import type { StockHqInfo } from './types';

// 字段映射
const FIELD_MAP: Record<string, keyof StockHqInfo> = {
  '4': 'code',
  '34338': 'market',
  '10': 'price',
  '34818': 'priceChangeRatio',
  '55': 'name',
  '233': 'high',
  '34821': 'priceChange',
  '9': 'low',
  '1': 'time',
  '6': 'pre',
};

export function mapFields(raw: Record<string, string[]>): Record<string, string[]> {
  return Object.keys(raw).reduce(
    (acc, key) => {
      acc[key] = raw[key];
      const mappedKey = FIELD_MAP[key];
      if (mappedKey) {
        acc[mappedKey] = raw[key];
      }
      return acc;
    },
    {} as Record<string, string[]>,
  );
}